import React from "react";
import "./PolicyPage.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <pre className="policy-text">
        <h1>Privacy Policy</h1>
{`Effective Date: 12 October 2025
Company Name: Recla Printing Products & Services
Email: reclacac@gmail.com
Phone: 08169405098
Address: GRA No. 77, Umuebeke Street, Aba, Abia State, Nigeria

At Recla Printing Products & Services, your privacy is important to us. This policy outlines how we collect, use, and protect your personal information when you visit our website, contact us, or engage with our services.

1. Information We Collect
We may collect the following information from you:
Name, email address, phone number, and company name
Billing, shipping, and payment details for order processing
Technical data such as IP address, browser type, and cookies
Any other information submitted through contact forms or quotation requests

2. How We Use Your Data
We use your data to:
Respond to enquiries and provide quotations
Process and fulfil product orders
Improve our services, website, and overall customer experience
Send order updates, product information, or newsletters (only if you choose to opt in)
We do not sell or rent your personal information to third parties.

3. Cookies & Analytics
Our website may use cookies and third-party analytics tools to:
Understand how users interact with our website
Improve navigation, performance, and usability
You can disable cookies at any time through your browser settings, although certain features of the website may not function properly without them.

4. Data Security
We maintain strict administrative and technical measures to protect your data from unauthorised access, alteration, or misuse.
Access to your personal data is restricted to authorised personnel only and is used solely for legitimate business purposes.

5. Third-Party Disclosure
We may share necessary information with trusted logistics, payment, or technical partners solely to complete your transaction or provide support.
All such partners are required to maintain confidentiality and comply with data protection obligations.

6. Your Rights
You have the right to:
View the information we hold about you
Request corrections or updates to your details
Ask for the deletion of your personal data (where legally permissible)
To exercise these rights, please contact us at reclacac@gmail.com.

7. Data Retention
We retain your personal data only for as long as necessary to:
Fulfil the purpose for which it was collected
Comply with legal, regulatory, or accounting obligations.
After this period, your data will be securely deleted or anonymised.

8. Policy Updates
We may update this Privacy Policy from time to time to reflect operational, legal, or regulatory changes.
The updated version will continuously be published on our website with a new effective date.

9. Contact Us
If you have any questions or concerns about this Privacy Policy or how your information is handled, please contact us at:
reclacac@gmail.com | 08169405098`}
      </pre>
    </div>
  );
};

export default PrivacyPolicy;
